import { Header } from '../../ui/header/header';
import { ProfileMenuItem } from '../../ui/header/header.model';
import { FC, ReactNode } from 'react';
import { useCore } from '../context/core.context';

interface HeaderWrapperProps {
  hide: boolean;
  profileMenuItems: ProfileMenuItem[];
  requiresAuthentication: boolean;
  className?: string;
  customHeader?: ReactNode;
  bannerHeader?: ReactNode;
}

export const HeaderWrapper: FC<React.PropsWithChildren<HeaderWrapperProps>> = ({
  hide,
  profileMenuItems,
  requiresAuthentication,
  className,
  customHeader,
  bannerHeader,
}) => {
  const { auth } = useCore();

  if (hide || (!requiresAuthentication && !auth.isAuthenticated)) {
    return null;
  }

  const displayName =
    auth.user?.given_name || auth.user?.family_name ? [auth.user?.given_name, auth.user?.family_name].filter(Boolean).join(' ') : undefined;

  return (
    <Header
      displayName={displayName}
      profileMenuItems={profileMenuItems}
      onLogout={auth.onLogout}
      className={className}
      customHeader={customHeader}
      bannerHeader={bannerHeader}
    />
  );
};
